import { useSelector } from "react-redux";
import EmptyCreatePage from "../../../../components/v2/EmptyCreatePage";
import { translations } from "../../../../utils/language";
import { isNuvemshopPlatform } from "../../pages/personalizar/routeMap";

const BoxPersonalizar = ({ onHelpClick }) => {
	const language = useSelector((state) => state.reducerLanguage);
	const lang = language?.data || "pt";

	const benefits = [
		translations["personalizar-beneficio-checkout"]?.[lang],
		isNuvemshopPlatform() ? translations["personalizar-beneficio-downloads"]?.[lang] : null,
		translations["personalizar-beneficio-email"]?.[lang],
		translations["personalizar-beneficio-marca-agua"]?.[lang],
	].filter(Boolean);

	return (
		<EmptyCreatePage
			showAlert={false}
			showButtons={!!onHelpClick}
			title={translations["personalizar-empty-title"]?.[lang] || "Personalize o Dijital"}
			description={
				translations["personalizar-empty-desc"]?.[lang] ||
				"Escolha no menu ao lado o que deseja personalizar."
			}
			helpButtonText={translations["Como Funciona"]?.[lang] || "Como Funciona"}
			onHelpClick={onHelpClick}
			benefits={benefits}
		/>
	);
};

export default BoxPersonalizar;
